import { render, staticRenderFns } from "./IP_ByDrgPrintable.vue?vue&type=template&id=f8309384&scoped=true&"
import script from "./IP_ByDrgPrintable.vue?vue&type=script&lang=js&"
export * from "./IP_ByDrgPrintable.vue?vue&type=script&lang=js&"
import style0 from "./IP_ByDrgPrintable.vue?vue&type=style&index=0&id=f8309384&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8309384",
  null
  
)

export default component.exports